module.exports = __webpack_public_path__ + "static/img/h35.c1f4243.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h35.jpg
// module id = 030K
// module chunks = 0